import { render, staticRenderFns } from "./ship-order.vue?vue&type=template&id=3c7d5227&scoped=true"
import script from "./ship-order.vue?vue&type=script&lang=ts"
export * from "./ship-order.vue?vue&type=script&lang=ts"
import style0 from "./ship-order.vue?vue&type=style&index=0&id=3c7d5227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7d5227",
  null
  
)

export default component.exports